export const transferStatusConfig: Record<string, { color: string; bgColor: string }> = {
  Pending: { color: 'text-warning', bgColor: 'bg-warning/15' },
  Approved: { color: 'text-info', bgColor: 'bg-info/15' },
  Scheduled: { color: 'text-primary', bgColor: 'bg-primary/15' },
  Delivering: { color: 'text-orange-600', bgColor: 'bg-orange-500/15' },
  AwaitingReceive: { color: 'text-violet-600', bgColor: 'bg-violet-500/15' },
  PickupReady: { color: 'text-cyan-600', bgColor: 'bg-cyan-500/15' },
  Completed: { color: 'text-success', bgColor: 'bg-success/15' },
  Rejected: { color: 'text-destructive', bgColor: 'bg-destructive/15' },
}
